import React, { useEffect, useState } from 'react';
import { createSubmission, getMySubmissions } from '../services/submissionService';
import authService from '../services/authService';
import Autocomplete from '../components/Autocomplete';
import LocationPicker from '../components/map/LocationPicker';
import { API_BASE_URL } from '../config/apiConfig';

const SubmitDataPage = () => {
  const user = authService.getCurrentUser();
  const [type, setType] = useState('newTera');
  const [payload, setPayload] = useState({});
  const [message, setMessage] = useState('');
  const [mySubs, setMySubs] = useState([]);
  const [teraOptions, setTeraOptions] = useState([]);

  useEffect(() => {
    if (user) {
      getMySubmissions().then(setMySubs).catch(()=>{});
    }
  }, [user]);

  useEffect(() => {
    // Fetch tera names for suggestions
  fetch(`${API_BASE_URL}/api/search/teras`)
      .then(r => r.ok ? r.json() : [])
      .then(list => setTeraOptions(Array.isArray(list) ? list : []))
      .catch(() => setTeraOptions([]));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    try {
      const res = await createSubmission(type, payload);
      setMessage('Submitted successfully.');
      setMySubs([res, ...mySubs]);
    } catch (e) {
      setMessage(e?.data?.message || 'Submission failed');
    }
  };

  const onChangePayload = (field, value) => setPayload(prev => ({ ...prev, [field]: value }));

  const inputBase = "w-full p-3 rounded-xl bg-white border border-gray-300 text-black placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:placeholder-gray-400";
  const renderFields = () => {
    switch (type) {
      case 'newTera':
        return (
          <div className="space-y-3">
            <input className={inputBase} placeholder="Tera name" onChange={e=>onChangePayload('name', e.target.value)} />
            <LocationPicker
              value={payload.lat && payload.lng ? { lat: Number(payload.lat), lng: Number(payload.lng) } : null}
              onChange={({ lat, lng }) => { onChangePayload('lat', lat); onChangePayload('lng', lng); }}
              height={320}
            />
            <div className="grid grid-cols-2 gap-2 text-sm text-gray-600 dark:text-gray-300">
              <div className="p-2 rounded border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800">Lat: {payload.lat ?? '-'}</div>
              <div className="p-2 rounded border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800">Lng: {payload.lng ?? '-'}</div>
            </div>
            <input className={inputBase} placeholder="Address (optional)" onChange={e=>onChangePayload('address', e.target.value)} />
            <select className={inputBase} onChange={e=>onChangePayload('condition', e.target.value)} defaultValue="good">
              <option value="good">Good</option>
              <option value="average">Average</option>
              <option value="poor">Poor</option>
            </select>
          </div>
        );
      case 'newRoute':
        return (
          <div className="space-y-3">
            <Autocomplete options={teraOptions} value={payload.fromTera || ''} onChange={v=>onChangePayload('fromTera', v)} placeholder="fromTera (ID or Name)" />
            <Autocomplete options={teraOptions} value={payload.toTera || ''} onChange={v=>onChangePayload('toTera', v)} placeholder="toTera (ID or Name)" />
            <input className={inputBase} placeholder="Fare" type="number" onChange={e=>onChangePayload('fare', Number(e.target.value))} />
            <input className={inputBase} placeholder="Estimated Time (min)" type="number" onChange={e=>onChangePayload('estimatedTimeMin', Number(e.target.value))} />
          </div>
        );
      case 'fareUpdate':
        return (
          <div className="space-y-3">
            <input className={inputBase} placeholder="routeId (or leave empty and fill from/to)" onChange={e=>onChangePayload('routeId', e.target.value)} />
            <Autocomplete options={teraOptions} value={payload.fromTera || ''} onChange={v=>onChangePayload('fromTera', v)} placeholder="fromTera (ID or Name)" />
            <Autocomplete options={teraOptions} value={payload.toTera || ''} onChange={v=>onChangePayload('toTera', v)} placeholder="toTera (ID or Name)" />
            <input className={inputBase} placeholder="New Fare" type="number" onChange={e=>onChangePayload('newFare', Number(e.target.value))} />
          </div>
        );
      case 'conditionUpdate':
        return (
          <div className="space-y-3">
            <Autocomplete options={teraOptions} value={payload.tera || ''} onChange={v=>onChangePayload('tera', v)} placeholder="tera (ID or Name)" />
            <select className={inputBase} onChange={e=>onChangePayload('condition', e.target.value)} defaultValue="good">
              <option value="good">Good</option>
              <option value="average">Average</option>
              <option value="poor">Poor</option>
            </select>
          </div>
        );
      default:
        return null;
    }
  };

  if (!user) {
    return <div className="p-6 max-w-3xl mx-auto" style={{ color: 'rgb(var(--text))' }}>Please login to submit data.</div>;
  }

  return (
    <div className="p-6 max-w-3xl mx-auto" style={{ color: 'rgb(var(--text))' }}>
      <h1 className="text-2xl font-bold mb-4">Contribute Route Data</h1>
      <form onSubmit={handleSubmit} className="space-y-4">
        <select className={inputBase} value={type} onChange={e=>{setType(e.target.value); setPayload({});}}>
          <option value="newTera">New Tera</option>
          <option value="newRoute">New Route</option>
          <option value="fareUpdate">Fare Update</option>
          <option value="conditionUpdate">Condition Update</option>
        </select>
        {renderFields()}
        {type === 'newTera' && payload.lng && payload.lat && (
          <small className="block" style={{ color: 'rgb(var(--muted))' }}>Coordinates will be sent as [lng, lat]</small>
        )}
        <button type="submit" className="px-4 py-2 rounded" style={{ backgroundColor: 'rgb(var(--brand))', color: '#fff' }}>Submit</button>
      </form>
  {/* datalist no longer needed since using Autocomplete component */}
      {message && <p className="mt-3 text-sm">{message}</p>}

      <h2 className="text-xl font-semibold mt-8 mb-2">My Submissions</h2>
    <div className="space-y-2">
        {mySubs.map(s => (
      <div key={s._id} className="p-3 border rounded flex items-center justify-between" style={{ backgroundColor: 'rgb(var(--surface))', borderColor: 'rgb(var(--border))' }}>
            <div>
              <div className="font-medium">{s.type}</div>
        <div className="text-sm" style={{ color: 'rgb(var(--muted))' }}>Status: {s.status}</div>
            </div>
            <div className="text-xs" style={{ color: 'rgb(var(--muted))' }}>{new Date(s.createdAt).toLocaleString()}</div>
          </div>
        ))}
    {mySubs.length === 0 && <div style={{ color: 'rgb(var(--muted))' }}>No submissions yet.</div>}
      </div>

    </div>
  );
};

export default SubmitDataPage;
